import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { IAppRootState } from 'src/app/core/store';

import { datablockOriginalReducer } from './datablock.reducer';
import {
	DatablockOriginalSliceState,
	DatablockSliceKey,
} from './datablock.state';

export const DatablockFeatureKey = 'Datablock';

export interface DatablockFeatureState {
	[DatablockSliceKey]: DatablockOriginalSliceState;
}

export interface DatablockRootState extends IAppRootState {
	[DatablockFeatureKey]: DatablockFeatureState;
}

export const featureSelector =
	createFeatureSelector<DatablockFeatureState>(DatablockFeatureKey);

export const datablockReducers: ActionReducerMap<DatablockFeatureState> = {
	[DatablockSliceKey]: datablockOriginalReducer,
};
